import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import { SnGridRef } from "@shared/components/GridV2/SnGridTypes";
import { global } from "@shared/libs/Global";

interface Props {
  Menuprops: menuInfo;
}

const SN_PRD_WRK_REP_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<SnGridRef> }>({
    grid1: React.createRef<SnGridRef>(),
  });

  const getGridCurrent = (key: string): SnGridRef => {
    const grid = gridRefs.current[key]?.current;
    if (!grid) {
      throw new Error(`Grid '${key}' is not mounted yet`);
    }
    return grid;
  };

  const { userInfo } = global(); // Login user 정보
  const searchRef = useRef<any>(null);

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding

  const [columns, setColums] = useState<any>({
    grid1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
  });

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        // 초기값에 공유로 받은 값이 있으면 덮어쓰지 않고 유지
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));

        setColums({
          grid1: rtn.grid.grid1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
  }));

  //#region onSearch
  const onSearch = async (searchData: any) => {
    try {
      const searchDataToUse = searchData || searchRef.current.getFormdata();
      const params = {
        id: "sn_prd_wrk_rep_001_01",
        params: searchDataToUse,
      };

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
      });
    } catch (error: any) {}
  };
  //#endregion

  //#region useMemo
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
      },
    }),
    [columns, dataSources]
  );
  //#endregion

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnGrid
          ref={gridRefs.current["grid1"]} // Grid Name
          columnConfig={grids.grid1.columns} // 컬럼 설정 전달
          rowData={grids.grid1.dataSource} // Datasource
          etcProps={{
            rowSelection: "multiple",
            title: "실적정보",
            isEditable: false,
          }}
        />
      </div>
    </div>
  );
});

export default SN_PRD_WRK_REP_001;
